import React, { Fragment, useState, useEffect } from "react";
import { useSelector } from "react-redux";

const Loader = () => {
  const globalLoading = useSelector(state => state?.loaderReducer?.loading || false);
  const [show, setShow] = useState(false);

  useEffect(
    () => {
      let timeout;
      if (globalLoading) {
        // When API call starts → immediately show loader
        setShow(true);
      } else {
        // When API call ends → wait 1s before hiding
        setShow(false);
      }

      return () => clearTimeout(timeout);
    },
    [globalLoading]
  );

  return (
    <Fragment>
      <div className={`loader-wrapper ${show ? "" : "loderhide"}`}>
        <div className="loader bg-transparent">
          <div className="whirly-loader" />
        </div>
      </div>
    </Fragment>
  );
};

export default Loader;
